import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const settingsModule = {
  state() {
    return {
      settings: null,
      grantConsent: 0,
    };
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
};
